"use client";

import { c as _c } from "react/compiler-runtime";
import { useAtom } from "@xstate/store/react";
import { createAtom } from "@xstate/store";
import { useEffect } from "react";
const issueTypeAtom = createAtom(null);
export function IssueTypeProvider(t0) {
  const $ = _c(3);
  const {
    issueType
  } = t0;
  let t1;
  let t2;
  if ($[0] !== issueType) {
    t1 = () => {
      issueTypeAtom.set(issueType);
      return _temp;
    };
    t2 = [issueType];
    $[0] = issueType;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
}
function _temp() {
  issueTypeAtom.set(null);
}
export function useIssueType() {
  return useAtom(issueTypeAtom);
}